module.exports = __webpack_public_path__ + "static/media/medium.7e0fca79.svg";